import DOMPurify from 'dompurify';

export const sanitizer = (str: string) => {
  return DOMPurify.sanitize(str, { ALLOWED_TAGS: [] });
};
